import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer" data-testid="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo" data-testid="footer-logo">
              <span className="logo-icon">🌐</span>
              <span className="logo-text">
                DANSTON<span className="logo-ai">AI</span>
              </span>
            </div>
            <p className="footer-tagline" data-testid="footer-tagline">
              AI That Works For You.
            </p>
          </div>

          <div className="footer-links">
            <a href="#hero" className="footer-link" data-testid="footer-link-home">Home</a>
            <a href="#solutions" className="footer-link" data-testid="footer-link-solutions">Solutions</a>
            <a href="#industries" className="footer-link" data-testid="footer-link-industries">Industries</a>
            <a href="#about" className="footer-link" data-testid="footer-link-about">About</a>
            <a href="#contact" className="footer-link" data-testid="footer-link-contact">Contact</a>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright" data-testid="footer-copyright">
            © 2025 DanstonAI. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
